import { ownerDb } from "@/services/common/db/dexie";

type TaskFilterState = {
  targetMonth: boolean;
  status: boolean;
  workFrequency: boolean;
  problem: boolean;
  crew: boolean;
  jobCategory: boolean;
};

/**
 * タスクフィルターの表示状態を取得
 */
const getTaskFilterState = async (): Promise<TaskFilterState | null> => {
  try {
    const filterState = await ownerDb.showTaskFilters.get(1);
    if (!filterState) return null;
    return filterState.filters;
  } catch (error) {
    console.error("Failed to get task filter state:", error);
    return null;
  }
};

/**
 * タスクフィルターの表示状態を保存
 */
const saveTaskFilterState = async (state: TaskFilterState): Promise<void> => {
  try {
    await ownerDb.showTaskFilters.put({ id: 1, filters: state });
  } catch (error) {
    console.error("Failed to save task filter state:", error);
  }
};

/**
 * タスクフィルターの表示状態をリセット
 */
const resetTaskFilterState = async (): Promise<void> => {
  try {
    await ownerDb.showTaskFilters.put({
      id: 1,
      filters: {
        targetMonth: true,
        status: true,
        workFrequency: true,
        problem: true,
        crew: false,
        jobCategory: false
      }
    });
  } catch (error) {
    console.error("Failed to reset task filter state:", error);
  }
};

export { getTaskFilterState, saveTaskFilterState, resetTaskFilterState };
